import Api from '../api'
import axios from '@/js/api'


// import Vue from 'vue'
// import VueRouter from 'vue-router'
import error404 from '../views/errorPage/404.vue'
import Login from '../views/login.vue'
import Workbench from '../views/workbench.vue'
import Home from '../views/Home.vue'
import Doctor from '../views/doctor/index.vue'
import ManagerPlan from '../views/manager/plan/index.vue' //方案
import ManagerTask from '../views/manager/task/index.vue' //任务
import ManagerSpecialist from '../views/manager/specialist/index.vue' //专家
import Supervisor from '../views/supervisor/index.vue' //监察员
import Visualization from '../views/visualization/index.vue' //监察员
import ImageCore from '../views/manager/plan/imageCore' //影像中心列表
import EditImageCore from '../views/manager/plan/editImageCore' //影像中心编辑
import Scoring from '../components/Common/scoring' //影像中心编辑


Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Login',
		component: Login
	},
	{
		path: '/workbench',
		name: 'Workbench',
		component: Workbench
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		children: [
			{
				path: '/home/admin/menuManagement', //菜单管理
				name: 'menuManagement',
				component: () =>
					import('@/views/admin/menuManagement'),
				meta: [{
					name: '菜单管理',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/admin/roleManagement', //角色管理
				name: 'roleManagement',
				component: () =>
					import('@/views/admin/roleManagement'),
				meta: [{
					name: '角色管理',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/admin/roleAuthorization', //角色授权
				name: 'roleAuthorization',
				component: () =>
					import('@/views/admin/roleAuthorization'),
				meta: [{
					name: '角色授权',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/admin/regionalManagement', //区域管理
				name: 'regionalManagement',
				component: () =>
					import('@/views/admin/regionalManagement'),
				meta: [{
					name: '区域管理',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/admin/userManagement', //用户管理
				name: 'userManagement',
				component: () =>
					import('@/views/admin/userManagement'),
				meta: [{
					name: '用户管理',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/plan/userManagement', //人员管理
				name: 'userManagement',
				component: () =>
					import('@/views/admin/userManagement'),
				meta: [{
					name: '人员管理',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/doctor/homePage', //审核医生概览
				name: 'doctorHomePage',
				component: () =>
					import('@/components/doctor/doctorHomePage'),
				meta: [{
					name: '概览',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/doctor/pending',
				name: 'DoctorPending',
				component: Doctor,
				meta: [{
					name: '任务列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/doctor/appealTable',
				name: 'appealTable',
				component:() =>
					import('@/components/doctor/appealTable'),
				meta: [{
					name: '申诉报告',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/arbitrate',
				name: 'arbitrate',
				component:() =>
					import('@/views/arbitrate'),
				meta: [{
					name: '申诉报告',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/doctor/doctorTable', //审核医生报告详情页
				name: 'doctorTable',
				component: () =>
					import('@/components/doctor/doctorTable'),
				meta: [{
					name: '报告列表',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/experts/arbitrationExpert', //仲裁专家
				name: 'arbitrationExpert',
				component:() =>
					import('@/components/experts/arbitrationExpert'),
				meta: [{
					name: '申诉报告',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/experts/expertHome', //质控专家概览
				name: 'ExpertHome',
				component: () =>
					import('@/components/experts/expertHomePage'),
				meta: [{
					name: '概览',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/experts/pending', //待质控
				name: 'DoctorPending',
				component: Doctor,
				meta: [{
					name: '任务列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/experts/expertsTable', //审核医生报告详情页
				name: 'expertsTable',
				component: () =>
					import('@/components/experts/expertsTable'),
				meta: [{
					name: '报告列表',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/task/taskall', //管理员任务-抽样列表
				name: 'ManagerTask',
				component: ManagerTask,
				meta: [{
					name: '抽样列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/task/sampleReport', //管理员任务-抽样任务
				name: 'ManagerTask',
				component: () =>
					import('@/components/manager/sampleReport'),
				meta: [{
					name: '抽样报告列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/task/taskall/newTask', //管理员任务-全部
				name: 'ManagerTask',
				component: () =>
					import('@/components/manager/details'),
				meta: [{
					name: '新建抽样任务',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/task/taskall/distributionTask', //管理员任务-分配
				name: 'distributionTask',
				component: () =>
					import('@/components/manager/distributionTask'),
				meta: [{
					name: '分配任务',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/task/tasksecondaryTable', //管理员任务-全部
				name: 'tasksecondaryTable',
				component: () =>
					import('@/components/manager/tasksecondaryTable'),
				meta: [{
					name: '任务详情',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/task/reviewReportList', //管理员任务-报告列表
				name: 'reviewReportList',
				component: () =>
					import('@/components/manager/reviewReportList'),
				meta: [{
					name: '报告列表',
					breadNumber: 4
				}, ],
			},
			{
				path: '/home/manager/task/redistribute',
				name: 'TaskRedistribute',
				component: () => import('@/views/manager/task/redistribute.vue'),
				meta: [{
					name: '重新分发',
					breadNumber: 4
				}, ],
			},
			{
				path: '/home/manager/task/distributeDetails',
				name: 'TaskDistributeDetails',
				component: () => import('@/views/manager/task/distributeDetails.vue'),
				meta: [{
					name: '分发详情',
					breadNumber: 4
				}, ],
			},
			{
				path: '/home/manager/task/replacementReport', //管理员任务-更换报告列表
				name: 'replacementReport',
				component: () =>
					import('@/components/manager/replacementReport'),
				meta: [{
					name: '更换报告列表',
					breadNumber: 5
				}, ],
			},
			{
				path: '/home/manager/specialist/panel', //管理员专家-专家组
				name: 'ManagerSpecialist',
				component: ManagerSpecialist,
				meta: [{
					name: '专家管理-全部',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/export/expertStatistics', //专家统计
				name: 'expertStatistics',
				component: () =>
					import('@/views/manager/export/expertStatistics'),
				meta: [{
					name: '专家统计',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/statistics/taskStatistics', //任务统计
				name: 'taskStatistics',
				component: () =>
					import('@/components/statistics/taskStatistics'),
				meta: [{
					name: '任务统计',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/statistics/loginStatistics', //登录统计
				name: 'loginStatistics',
				component: () =>
					import('@/components/statistics/loginStatistics'),
				meta: [{
					name: '登录统计',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/statistics/exportStatistics', //评估报告
				name: 'exportStatistics',
				component: () =>
					import('@/components/statistics/exportStatistics'),
				meta: [{
					name: '评估报告',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/dataExport/list', //数据导出
				name: 'DataExportList',
				component: () => import('@/views/dataExport/index.vue'),
				meta: [
					{
						name: '数据导出',
						breadNumber: 1
					}
				]
			},
			{
				path: '/home/dataExport/details', // 数据导出详情
				name: 'DataExportDetails',
				component: () => import('@/views/dataExport/details.vue'),
				meta: [
					{
						name: '任务详情',
						breadNumber: 2
					}
				]
			},
			// {
			// 	path: '/home/manager/specialist/groupwithin', //管理员专家-集团内
			// 	name: 'ManagerSpecialist',
			// 	component: ManagerSpecialist,
			// 	meta: [{
			// 		name: '专家管理-集团内',
			// 		breadNumber: 1
			// 	}, ],
			// },
			// {
			// 	path: '/home/manager/specialist/groupoutside', //管理员专家-集团外
			// 	name: 'ManagerSpecialist',
			// 	component: ManagerSpecialist,
			// 	meta: [{
			// 		name: '专家管理-集团外',
			// 		breadNumber: 1
			// 	}, ],
			// },
			// {
			// 	path: '/home/manager/specialist/committee', //管理员专家-专委会
			// 	name: 'ManagerSpecialist',
			// 	component: ManagerSpecialist,
			// 	meta: [{
			// 		name: '专家管理-专委会',
			// 		breadNumber: 1
			// 	}, ],
			// },
			{
				path: '/home/specialist/newSpecialistDetails', //管理员任务-专家
				name: 'newSpecialistDetails',
				component: () =>
					import('@/components/specialist/newSpecialistDetails'),
				meta: [{
					name: '新建专家',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/specialist/newSpecialistDetailsedit', //管理员任务-专家
				name: 'newSpecialistDetails',
				component: () =>
					import('@/components/specialist/newSpecialistDetails'),
				meta: [{
					name: '修改专家',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/workload/workload', //专家工作量
				name: 'ManagerSpecialist',
				component: ManagerSpecialist,
				meta: [{
					name: '专家工作量',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/workingteam', //工作组管理
				name: 'ManagerSpecialist',
				component: ManagerSpecialist,
				meta: [{
					name: '工作组管理',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/newWorkingTeamDetails', //工作组操作
				name: 'newWorkingTeamDetails',
				component: () =>
					import('@/components/specialist/newWorkingTeamDetails'),
				meta: [{
					name: '新建工作组',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/newWorkingTeamDetailsedit', //工作组操作
				name: 'newWorkingTeamDetails',
				component: () =>
					import('@/components/specialist/newWorkingTeamDetails'),
				meta: [{
					name: '修改工作组',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/plan/scheme', //管理员评分方案
				name: 'ManagerPlan',
				component: ManagerPlan,
				meta: [{
					name: '评分方案',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/plan/newSchemeDetails', //评分方案
				name: 'newSchemeDetails',
				component: () =>
					import('@/components/plan/newSchemeDetails'),
				meta: [{
					name: '修改评分方案',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/plan/newSchemeDetailsadd', //评分方案
				name: 'newSchemeDetails',
				component: () =>
					import('@/components/plan/newSchemeDetails'),
				meta: [{
					name: '新建评分方案',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/plan/rules', //管理员评分细则
				name: 'ManagerPlan',
				component: ManagerPlan,
				meta: [{
					name: '评分细则',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/plan/imageCore', //影像中心列表
				name: 'imageCore',
				component: ImageCore,
				meta: [{
					name: '影像中心列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/plan/editImageCore', //影像中心编辑
				name: 'editImageCore',
				component:EditImageCore,
				meta: [{
					name: '影像中心编辑',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/manager/plan/inspectionItems', //检查项目列表
				name: 'inspectionItems',
				component: () =>
					import('@/views/manager/plan/inspectionItems'),
				meta: [{
					name: '检查项目列表',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/fileUpload/list', //文件上传
				name: 'fileUploadList',
				component: () =>
					import('@/views/manager/fileUpload/index.vue'),
				meta: [{
					name: '文件上传',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/fileUpload/liststandard', //标准共识文件上传
				name: 'liststandard',
				component: () =>
					import('@/views/manager/fileUpload/index.vue'),
				meta: [{
					name: '文件上传',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/plan/newRulesDetailsadd', //新建评分细则
				name: 'newRulesDetailsadd',
				component: () =>
					import('@/components/plan/newRulesDetails'),
				meta: [{
					name: '新建评分细则',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/plan/newRulesDetails', //编辑评分细则
				name: 'newRulesDetails',
				component: () =>
					import('@/components/plan/newRulesDetails'),
				meta: [{
					name: '编辑评分细则',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/supervisor', //监察员
				name: 'Supervisor',
				component: Supervisor,
				meta: [{
					name: '监察员'
				}, ],
			},
			{
				path: '/home/visualization', //数据可视化
				name: 'Visualization',
				component: Visualization,
				meta: [{
					name: '数据可视化'
				}, ],
			},
			{
				path: '/home/visualization/vieMoreReports', //全国技师/医生排名
				name: 'vieMoreReports',
				component: () =>
					import('@/components/visualization/vieMoreReports'),
				meta: [{
					name: '全国医生排名',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/visualization/visImageCenter', //影像中心大屏
				name: 'visImageCenter',
				component: () =>
					import('@/components/visualization/visImageCenter'),
				meta: [{
					name: '影像中心',
					breadNumber: 3
				}, ],
			},
			{
				path: '/home/visualization/visRegion', //区域大屏
				name: 'visRegion',
				component: () =>
					import('@/components/visualization/visRegion'),
				meta: [{
					name: '区域',
					breadNumber: 2
				}, ],
			},
			{
				path: '/home/visualization/visPersonalAssessment', //个人评估大屏
				name: 'visPersonalAssessment',
				component: () =>
					import('@/components/visualization/visPersonalAssessment'),
				meta: [{
					name: '个人评估',
					breadNumber: 5
				}, ],
			},
			{
				path: '/home/visualization/visAllPrevious', //抽样报告列表
				name: 'visAllPrevious',
				component: () =>
					import('@/components/visualization/visAllPrevious'),
				meta: [{
					name: '历次质控结果',
					breadNumber: 5
				}, ],
			},
			{
				path: '/home/supervisor/qualifiedTable', //抽样报告列表
				name: 'qualifiedTable',
				component: () =>
					import('@/components/supervisor/qualifiedTable'),
				meta: [{
					name: '抽样报告列表',
					breadNumber: 7
				}, ],
			},
			{
				path: '/home/supervisor/centralStatistics', //中心统计
				name: 'centralStatistics',
				component: () =>
					import('@/components/supervisor/centralStatistics'),
				meta: [{
					name: '概览',
					breadNumber: 3
				}, ],
			},
			{
				path: '/home/supervisor/centerDirector', //中心主任角色
				name: 'centerDirector',
				component: () =>
					import('@/components/supervisor/centralStatistics'),
				meta: [{
					name: '概览',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/doctor/scoring', //审核医生报告详情页
				name: 'scoring',
				// component: () =>
				// 	import('@/components/Common/scoring'),
				component: Scoring,
				meta: [{
					name: '报告详情',
					breadNumber: 8
				}, ],
			},
			{
				path: '/home/manager/scoring', //审核医生报告详情页
				name: 'scoring',
				component:Scoring,
				meta: [{
					name: '报告详情',
					breadNumber: 8
				}, ],
			},
			{
				path: '/home/scene/recordTable', //现场质控-现场质控记录
				name: 'RecordTable',
				component: () =>
					import('@/components/scene/recordTable'),
				meta: [{
					name: '现场质控记录',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/scene/scoringStandard', //现场质控-现场质控评分标准
				name: 'ScoringStandard',
				component: () =>
					import('@/views/scene/scoringStandard'),
				meta: [{
					name: '现场质控评分标准',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/scene/imageRating', //现场质控-现场质控评分标准
				name: 'ImageRating',
				component: () =>
					import('@/views/scene/imageRating'),
				meta: [{
					name: '影像报告评分标准',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/scene/imagingReport', //现场质控-患者影像报告抽样
				name: 'ImagingReport',
				component: () =>
					import('@/components/scene/imagingReport'),
				meta: [{
					name: '患者影像报告抽样',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/scene/siteProcess', //现场质控-现场质控工作流程
				name: 'SiteProcess',
				component: () =>
					import('@/views/scene/siteProcess'),
				meta: [{
					name: '现场质控工作流程',
					breadNumber: 1
				}, ],
			},
			// {
			// 	path: '/home/manager/dataMaintenance/list',
			// 	name: 'dataMaintenanceList',
			// 	component: () => import('@/views/manager/dataMaintenance/list.vue'),
			// 	meta: [{
			// 		name: '数据维护',
			// 		breadNumber: 1
			// 	}, ],
			// },
			{
				path: '/home/manager/dataQuery/list',
				name: 'dataQueryList',
				component: () => import('@/views/manager/dataQuery/index.vue'),
				meta: [{
					name: '数据查询',
					breadNumber: 1
				}, ],
			},
			{
				path: '/home/manager/imageUploading/list',
				name: 'dataMaintenanceList',
				component: () => import('@/views/manager/imageUploading/imageUploadingList.vue'),
				meta: [{
					name: '影像上传列表',
					breadNumber: 1
				}, ],
			},
		]
	},
	{
		path: '*',
		name: 'error404',
		component: error404
	}
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location){
	return originalPush.call(this,location).catch(err => err)
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_STATIC,
	routes
})


export default router
